import { setDataValue } from '../../form-sync';

export default {
    setDataValue,

    /**
     * Set fetched locations
     * @param {Object} state
     * @param {Array} locations
     */
    setLocations(state, locations) {
        state.locations = locations;
    },

    /**
     * Set locations loading state
     * @param {Object} state
     * @param {Number} locationsLoading
     */
    setLocationsLoading(state, locationsLoading) {
        state.locatationsLoading = locationsLoading;
    },
};
